//footer first row static data
export const footerCategories = [
  {
    section: "NEWS",
    subSections: [
      "Home Page",
      "World",
      "Coronavirus",
      "U.S.",
      "Politics",
      "New York",
      "Business",
      "Tech",
      "Science",
      "Climate",
      "Sports",
      "Winter Olympics",
      "Wildfire Tracker",
      "Obituaries",
      "Today's Paper",
      "Corrections",
      "Trending",
    ],
  },
  {
    section: "OPINION",
    subSections: [
      "Today's Opinion",
      "Columnists",
      "Editorials",
      "Guest Essays",
      "Letters",
      "Sunday Review",
      "Video: Opinion",
    ],
  },
  {
    section: "ARTS",
    subSections: [
      "Today's Arts",
      "Art & Design",
      "Books",
      "Best Sellers Book List",
      "Dance",
      "Movies",
      "Music",
      "Pop Culture",
      "Television",
      "Theater",
      "Video: Arts",
    ],
  },
  {
    section: "LIVING",
    subSections: [
      "Automotive",
      "Games",
      "Education",
      "Food",
      "Health",
      "Jobs",
      "Love",
      "Magazine",
      "Parenting",
      "Real Estate",
      "Style",
      "T Magazine",
      "Travel",
    ],
  },
  {
    section: "MORE",
    subSections: [
      "Reader Center",
      "Wirecutter",
      "Cooking",
      "Live Events",
      "The Learning Network",
      "Tools & Services",
      "Podcasts",
      "Video",
      "TimesMachine",
      "NYT Store",
      "Manage My Account",
      "NYTLicensing",
    ],
  },
];

// footer second row static data
export const footerLastRowData = [
  "© 2023 The New York Times Company",
  "NYTCo",
  "Contact Us",
  "Accessibility",
  "Work with us",
  "Advertise",
  "T Brand Studio",
  "Your Ad Choices",
  "Privacy Policy",
  "Terms of Service",
  "Terms of Sale",
  "Site Map",
  "Help",
  "Subscriptions",
];
